import { Box, Container, Typography } from "@mui/material";
import { Fragment } from "react";
import CommonHeader from "../../components/common/commonHeader/CommonHeader";
import PaymentTable from "../../components/PaymentComponents/PaymentTable";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPayments } from "../../apiCalls/userApiCalls";

export const PaymentPage = () => {
  const user =  JSON.parse(sessionStorage.getItem("user"));
  const dispatch = useDispatch();

  useEffect(() => {
    getPayments(user?._id,dispatch)
  } ,[]);

  const payments=useSelector((state)=>state.payment?.payments)

  return (
    <Fragment>
      <CommonHeader />
      <Box sx={{ width:"100%",height:"80px" }}>
      </Box>
      <Container maxWidth="lg">
        <Typography variant="h6" gutterBottom component="div">
          Payment Details
        </Typography>
        <PaymentTable payments={payments}/>
      </Container>
    </Fragment>
  );
};
